import { CancelledError } from '@h5web/app';
import { type FallbackProps } from 'react-error-boundary';

import styles from './ErrorFallback.module.css';
import { HibouError } from './errors';
import { prepareReport } from './utils';

interface Props extends FallbackProps {
  className?: string;
  error: unknown;
}

function ErrorFallback(props: Props) {
  const { className = '', error, resetErrorBoundary } = props;

  const msg = error instanceof Error ? error.message : 'Unknown error';
  const isHibouError = error instanceof HibouError;

  if (error instanceof CancelledError) {
    return (
      <div className={`${styles.root} ${className}`}>
        <p className={styles.error}>&gt;&gt; Request cancelled</p>
        <div className={styles.actions}>
          <button
            className={styles.btn}
            type="button"
            onClick={() => resetErrorBoundary()}
          >
            Retry?
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.root} ${className}`}>
      <p className={styles.advice}>
        <strong>
          {(isHibouError && error.headline) || 'An error occurred.'}
        </strong>
        {(isHibouError && error.advice) ||
          'Please try again or report the error if it persists.'}
      </p>

      <p className={styles.error}>&gt;&gt; {msg}</p>

      <div className={styles.actions}>
        {(!isHibouError || error.allowReload) && (
          <button
            className={styles.btn}
            type="button"
            onClick={() => globalThis.location.reload()}
          >
            Reload page
          </button>
        )}
        <a
          className={styles.btn}
          target="_blank"
          href={`mailto:h5web@esrf.fr?subject=[Hibou]%20Error%20report&body=${encodeURIComponent(
            prepareReport(msg),
          )}`}
          rel="noreferrer"
        >
          Report error
        </a>
      </div>
    </div>
  );
}

export default ErrorFallback;
